import { css } from '@emotion/css';

import { mobileMediaQuery, nonMobileMediaQuery } from '../../constants';
import { m } from '../../motif';

export const breadcrumbCss = css`
  inset-block: 0 auto;
  inset-inline: 0;
  position: absolute;
  /** Allow tooltip to show on top the Hero text */
  z-index: 10;
`;

export const bgDarkGradientCss = css`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
`;

export const bgLightGradientCss = css`
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
`;

export const breadcrumbsListCss = css`
  align-items: center;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, auto));
  justify-content: start;
  list-style: none;
  padding-block: ${m('--spacing-xs')};
  /**
    * Hardcoded calc(28px - ${m(
    '--spacing-xxs'
  )})  to align the element with the first element on the header and to make the dependency on the breadcrumb padding explicit.
    * Find the design in the jira ticket: https://jira.sc-corp.net/browse/WEBP-11085
    */
  padding-inline: calc(28px - ${m('--spacing-xxs')}) ${m('--spacing-xxs')};

  ${nonMobileMediaQuery} {
    padding-block: ${m('--spacing-m')};
    /**
     * Hardcoded calc(60px - ${m(
      '--spacing-xxs'
    )})  to align the element with the first element on the header and to make the dependency on the breadcrumb padding explicit.
    * Find the design in the jira ticket: https://jira.sc-corp.net/browse/WEBP-11085
    */
    padding-inline: calc(60px - ${m('--spacing-xxs')}) ${m('--spacing-l')};
    max-width: 50%;
  }
`;

export const breadcrumbsListItemCss = css`
  display: flex;
  position: relative;

  /** Add separator for list items except the last one */
  &:not(:last-of-type)::after {
    color: ${m('--action-default-color')};
    content: '/';
    font-size: ${m('--annotation-mobile-font-size')};
    font-weight: ${m('--annotation-mobile-font-weight')};
    letter-spacing: ${m('--annotation-mobile-font-letter-spacing')};
    line-height: ${m('--annotation-mobile-font-line-height')};
    padding: ${m('--spacing-xs')};

    ${nonMobileMediaQuery} {
      font-size: ${m('--annotation-desktop-font-size')};
      font-weight: ${m('--annotation-desktop-font-weight')};
      letter-spacing: ${m('--annotation-desktop-font-letter-spacing')};
      line-height: ${m('--annotation-desktop-font-line-height')};
    }
  }

  ${mobileMediaQuery} {
    display: none;

    /** Hide the trailing slash */
    &::after {
      display: none;
    }
  }
`;

export const breadcrumbsListItemShowMobileCss = css`
  ${mobileMediaQuery} {
    display: flex;
  }
`;
